<template>
  <!--
        action: 上传图片的地址
        list-type：展示类型
        limit 上传个数限制
        auto-upload 选取文件后就上传 开启
        file-list 文件列表
        on-exceed  超出上传限制时的行为
        on-change 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
        before-upload 限制用户上传的图片格式和大小。 若返回 false 或者返回 Promise 且 reject，则停止上传
        before-upload 限制用户上传的图片格式和大小。 
        name: 图片上传后台需要的name
        headers: 请求头
        data：上传时附带的额外参数
        multiple
        硬编码：
        on-preview：点击文件列表中已上传的文件时的钩子
        name="importExcel" 必不可少
        -->
  <el-upload
    class="ex-upload"
    :action="'/dpt-web' + urlAction"
    name="importExcel"
    :show-file-list="false"
    :limit="limit"
    :data="exData"
    :on-error="handleError"
    :on-success="handleSucces"
    :before-upload="handleBefore"
    accept=".xlsx,.xls"
  >
    <el-button type="primary">导入</el-button>
  </el-upload>
</template>

<script>
export default {
  props: {
    urlAction: "",
    exData: "",
  },
  created() {},
  data() {
    return {
      limit: 100, //限制上传个数
    };
  },

  methods: {
    handleBefore(file) {
      //后缀名类型判断
      let FileExt = file.name.replace(/.+\./, "");

      if (["xls", "xlsx"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为xls, xlsx的EXCEl !",
        });
        return false;
      }
      //文件大小判断
      if (file.size / 1024 / 1024 > 1024) {
        this.$message.error("上传文件大小必须小于1024MB！");
        return false;
      }
    },
    //上传成功
    handleSucces(response, file, fileList) {
      if (response.resultCode === 200) {
        this.$message({ type: "success", message: response.data });
        this.$emit("selectLsit");
      } else {
        this.$message({
          type: "error",
          message: response.msg || "导入失败，请稍后重试。",
        });
      }
    },
    //失败
    handleError() {
      this.$message.warning("上传失败请稍后重试！");
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.ex-upload {
  margin-left: 10px;
  display: inline-block;
}
</style>
